/** Normalize common Russian mobile inputs to +7XXXXXXXXXX. */
export function normalizeRuMobilePhone(raw: string): string {
  let digits = raw.replace(/\D/gu, '');
  if (digits.length === 10) digits = `7${digits}`;
  if (digits.startsWith('8')) digits = `7${digits.slice(1)}`;
  return `+${digits}`;
}

/** The quiz promises a messenger reply, so only Russian mobile +79 numbers are valid. */
export function isValidRuMobilePhone(raw: string): boolean {
  return /^\+79\d{9}$/u.test(normalizeRuMobilePhone(raw));
}
